module.exports = __webpack_public_path__ + "img/9788949123189.cfd2986b.jpg";